var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaPageNotFound',{staticClass:"not-found",attrs:{"text-color":"white"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var linkText = ref.linkText;
return [_c('RouterLink',{staticClass:"link",attrs:{"replace":"","to":_vm.rootLink}},[_vm._v(" "+_vm._s(linkText)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }